import React from "react";

function Loggedout() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
      }}
    >
      <h1 className="mt-40">Please Login To continue</h1>
    </div>
  );
}

export default Loggedout;
